module.exports = __webpack_public_path__ + "static/BrandonGrotesque-Regular-6986e48655101ace934dfab4d0baf46c.woff";